export const messageForwardingEn = {
  forwardMessage: 'Forward message',
  forwardMessageToChat: 'Forward message to chat...',
  forwardedMessage: 'Forwarded message:',
  checkSendMessagesWarning:
    'You are not allowed to send messages to this chat, contact your company administrator',
  viewWarning:
    'You are not allowed to view this chat, contact your company administrator'
}

export const messageForwardingRu: typeof messageForwardingEn = {
  forwardMessage: 'Переслать сообщение',
  forwardMessageToChat: 'Переслать сообщение в чат...',
  forwardedMessage: 'Пересланное сообщение:',
  checkSendMessagesWarning:
    'Вам не разрешено отправлять сообщения в этот чат, обратитесь к администратору вашей компании',
  viewWarning:
    'Вам не разрешено просматривать этот чат, обратитесь к администратору вашей компании'
}
